// Baris RPC `preorder_inherited_pricing` (Fase 4, mig 3640/7900) → bentuk
// `InheritedPricing` yang dipakai `resolveSelectionPrice` (`catalog.inherited`).
// SATU pemeta untuk pembaca toko (`resolvePublicInheritedPricing`, klien anon)
// dan editor bundel admin (`fetchBundleProductFacts`, sesi admin — bughunt
// D15-23), supaya keduanya membaca warisan slot persis sama.

import type { InheritedPricing } from "@/lib/supabase/public-data";

export type InheritedPricingRpcRow = {
  price_normal: number | string | null;
  diskon_mode: "persen" | "nominal" | null;
  diskon_reseller: number | string | null;
  diskon_agen: number | string | null;
  diskon_slot3: number | string | null;
  diskon_slot4: number | string | null;
  diskon_slot5: number | string | null;
  diskon_slot6: number | string | null;
  diskon_slot7: number | string | null;
  diskon_slot8: number | string | null;
  diskon_slot9: number | string | null;
  diskon_slot10: number | string | null;
  diskon_slot11: number | string | null;
  diskon_slot12: number | string | null;
  diskon_slot13: number | string | null;
  diskon_slot14: number | string | null;
  diskon_slot15: number | string | null;
  /** mig 7900 (berkas 7950): tambahan yang diwarisi; absen sebelum 7950. */
  price_extra?: number | string | null;
};

/** Baris pertama RPC → `InheritedPricing`; tanpa baris = null (bukan berharga). */
export function inheritedPricingFromRows(rows: readonly InheritedPricingRpcRow[] | null | undefined): InheritedPricing | null {
  const first = rows?.[0];
  if (!first) return null;
  // `numeric` PostgreSQL tiba sebagai string lewat PostgREST.
  const num = (v: number | string | null | undefined): number | undefined => {
    if (v === null || v === undefined) return undefined;
    const n = typeof v === "string" ? Number(v) : v;
    return Number.isFinite(n) ? n : undefined;
  };
  return {
    priceNormal: num(first.price_normal) ?? null,
    diskonMode: first.diskon_mode ?? undefined,
    diskonReseller: num(first.diskon_reseller),
    diskonAgen: num(first.diskon_agen),
    diskonSlot3: num(first.diskon_slot3),
    diskonSlot4: num(first.diskon_slot4),
    diskonSlot5: num(first.diskon_slot5),
    diskonSlot6: num(first.diskon_slot6),
    diskonSlot7: num(first.diskon_slot7),
    diskonSlot8: num(first.diskon_slot8),
    diskonSlot9: num(first.diskon_slot9),
    diskonSlot10: num(first.diskon_slot10),
    diskonSlot11: num(first.diskon_slot11),
    diskonSlot12: num(first.diskon_slot12),
    diskonSlot13: num(first.diskon_slot13),
    diskonSlot14: num(first.diskon_slot14),
    diskonSlot15: num(first.diskon_slot15),
    priceExtra: num(first.price_extra ?? null) ?? null
  };
}
